/* global appData */

import { mapState } from 'vuex';

// Template and media files
import template from './share.vhtml';
import icon from '../../../_img/icons/icon-share.svg';

export default {
	template: template,
	components: {
		icon
	},
	data: () => ({
		label: appData.appSettings.share_screen.heading,
		isActive: appData.appSettings.activate_share,
	}),
	computed: {
		...mapState({
			isOpen: state => state.share.isOpen,
		}),
	}
};


// WEBPACK FOOTER //
// ./assets/_js/components/share/share.js